import { Box, Button, Modal } from "@shopify/polaris";
import React from "react";
import "./index.css";
const Index = ({ listData, handleSelect, setListData,handleTabChange }) => {
  return (
    <div>
      <Modal
        open={listData.open}
        onClose={() => {
          setListData((prevValue) => {
            return {
              ...prevValue,
              list:listData.list,
              open: false,
              loading: false,
            };
          });
          handleTabChange()
        }}
        loading={listData.loading}
      >
          <Box className="fourth_coupon__content" style={{backgroundImage:"url(/sub/coupon_modal_bg.png)"}}>
            <Box className="fourth_content_coupon_top">
              <img src="/sub/coupon_modal_bg_text.png" alt="Dropshipman" />
            </Box>
            <Box className="fourth_content_coupon_content">
              {listData.list.map((item, ind) => (
                <div
                  key={ind}
                  className="coupon_info"
                  style={{
                    backgroundImage: `url(${item.bg})`,
                  }}
                >
                  <div className="coupon_info_content">
                    <div className="coupon_left">
                      <div className="coupon_text">
                        <span
                          className="coupon_text_money"
                          style={{
                            color: "#303030",
                          }}
                        >
                          ${item.price} USD{"*" + item.num}
                        </span>
                        <span
                          className="coupon_text_explain"
                          style={{
                            color: "#303030",
                          }}
                        >
                          {item.title}
                        </span>
                      </div>
                      <div
                        className="coupon_text_time"
                        style={{
                          color: "#303030",
                        }}
                      >
                        {item.over}{" "}
                      </div>
                    </div>

                    <div className="coupon_right">
                      <Button
                        disabled={item.slelect}
                        loading={item.loading}
                        variant="primary"
                        onClick={() => {
                          handleSelect(ind);
                        }}
                      >
                        Claim
                      </Button>
                    </div>
                  </div>
                </div>
              ))}
            </Box>
          </Box>
      </Modal>
    </div>
  );
};

export default Index;
